import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('react-root');

if (rootElement) {
  const galleryImages = Array.isArray(window.mofetDomeGalleryImages) && window.mofetDomeGalleryImages.length
    ? window.mofetDomeGalleryImages
    : (() => {
        try {
          return JSON.parse(rootElement.dataset.gallery || '[]');
        } catch (error) {
          return [];
        }
      })();

  if (galleryImages.length) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
}
